import React, { useContext, useEffect, useState } from 'react';
import { EventContext } from '../context/EventContext';
import { getBills } from '../services/billingService';
import { Bill } from '../types/Bill';
import BillsTable from './BillsTable';
import { UserRoleContext } from '../context/UserRoleContext';
import { useToast } from '../context/ToastContext';

export const BillingComponent: React.FC = () => {
  const [bills, setBills] = useState<Bill[]>(); // State for the event code
  const { userRole } = useContext(UserRoleContext); // Role context
  const { addToast }  = useToast();


  useEffect(() => {
    const fetchBills = async () => {
      try {
        if (!userRole?.host_id) {
          addToast('Only hosts may view event bills.', true);
          return;
        }
        const bills = await getBills(userRole.host_id);
        setBills(bills);
      } catch (error) {
        console.error("Error fetching :", error);
        addToast('Error fetching bills', true);
      }
    };
    fetchBills();
  }, [userRole]);

  return (
    <div>
    <h2>Billing</h2>
    <BillsTable bills={bills} />
    </div>
  );
};
